import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { Button, TYPE } from 'components/Button'
import Icon from 'components/Icon'
import { UI } from 'Icon/ui'
import { Dispatch } from 'redux'
import { AppState } from '../../data/state'

interface NumberPeopleProps {
  openPersonModal: () => void
  total: number
  disabled?: boolean
  negative?: boolean
}

const NumberPeople: React.FC<NumberPeopleProps> = props => {
  return (
    <>
      {props.disabled ? <Button type={TYPE.lock} /> : null}
      <Button
        className={`number-people-btn`}
        type={TYPE.inlinetext}
        onClick={props.openPersonModal}
        disabled={props.disabled}
        negative={props.negative}
      >
        <DisplayContent
          addNode
          edit={true}
          contentKey="people"
          vars={{ total: props.total.toString() }}
        >
          {`People: ${props.total} `}
        </DisplayContent>
        <Icon icon={UI.triangleDown} />
      </Button>
    </>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  openPersonModal: () => {
    dispatch(actions.change('ui.viewPersonModal', true))
  },
})

export default connect(
  (state: AppState) => ({
    total:
      state.funnelOrder.numberOfAdults +
      state.funnelOrder.numberOfChildren +
      state.funnelOrder.numberOfBabies,
  }),
  mapDispatchToProps,
)(NumberPeople)
